<h2 mat-dialog-title>Modifier le profil</h2>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Prénom et Nom</mat-label>
    <input matInput [(ngModel)]="data.publicName">
  </mat-form-field>
  <br>
  <mat-form-field>
    <mat-label>Téléphone</mat-label>
    <input matInput [(ngModel)]="data.telephone">
  </mat-form-field>
  <br>
  <mat-form-field>
    <mat-label>Profession</mat-label>
    <input matInput [(ngModel)]="data.profession">
  </mat-form-field>
  <br>
  <mat-form-field>
    <mat-label>Ville</mat-label>
    <input matInput [(ngModel)]="data.ville">
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Annuler</button>
  <button mat-button (click)="onSave()">Enregistrer</button>
</div>
